import React               from 'react';
import { Observe }         from 'rewire-core';
import {
  ToggleMenu,
  WithStyle
}                          from 'rewire-ui';
import { PopoverOrigin }   from '@material-ui/core/Popover';
import { Theme }           from '@material-ui/core/styles';
import PrinterSettingsIcon from '../icons/PrinterSettingsIcon';
import reportFormatsModel  from './ReportFormatsModel';
import { withStyles }      from '../utility/styles';


const styles = (_theme: Theme) => ({
  root: {
    display: 'flex',
    flex: '0 0 auto',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    marginBottom: '7px',
  },
  menuButton: {
    minWidth: '0px',
    minHeight: '0px',
    padding: '0px',
    marginLeft: '15px',
  },
});

interface IReportFormatProps {
  classes?: any;
}

type ReportFormatProps = WithStyle<ReturnType<typeof styles>, IReportFormatProps>;

class ReportFormats extends React.PureComponent<ReportFormatProps> {
  constructor(props: ReportFormatProps) {
    super(props);
  }

  render() {

    return <Observe render={() => {
      const { classes }                    = this.props;
      const anchorOrigin:    PopoverOrigin = {vertical: 'bottom', horizontal: 'right'};
      const transformOrigin: PopoverOrigin = {vertical: 'top',    horizontal: 'right'};
      const buttonContent                  = <PrinterSettingsIcon />;
      const buttonProps                    = {disableRipple: true};
      const items                          = reportFormatsModel?.items ?? [];

      if (items.length == 0) return null;

      return (
        <div className={classes.root}>
          <ToggleMenu
            menuId='report-formats-toggle-menu'
            classes={{menuButton: classes.menuButton}}
            buttonContent={buttonContent}
            buttonProps={buttonProps}
            getContentAnchorEl={null}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
            tooltip='Report Formats'
            items={items}
          />
        </div>
      );
    }} />;
  }
}

export default withStyles<IReportFormatProps>(styles, ReportFormats);
